import React from 'react';
import { Seo } from './components/Seo';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { BoardRoles } from './components/BoardRoles';
import { Career } from './components/Career';
import { Education } from './components/Education';
import { Publications } from './components/Publications';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen font-sans text-navy bg-offwhite antialiased selection:bg-gold/30 selection:text-navy" data-id="element-0">
      <Seo data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <About data-id="element-5" />
        <BoardRoles data-id="element-6" />
        <Career data-id="element-7" />
        <Education data-id="element-8" />
        <Publications data-id="element-9" />
        <Contact data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}